import { Component, Input, OnInit, inject } from '@angular/core';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { AccountAuthorization } from 'src/model/accountAuthorization';
import { CustomerAccount } from 'src/model/customerAccount.model';
import { ProcessAuthorizationComponent } from '../process-authorization/process-authorization.component';

@Component({
    selector: 'app-account-authorization-card',
    templateUrl: './account-authorization-card.component.html',
    styleUrl: './account-authorization-card.component.scss',
    standalone: false
})
export class AccountAuthorizationCardComponent implements OnInit {
  protected sharedService = inject(SharedService);


  @Input() authorization: AccountAuthorization;
  @Input() customerAccount: CustomerAccount;

  ngOnInit(): void {

  }

  openProcessAuthorizationModal() {
    const modalRef = this.sharedService.openModal(ProcessAuthorizationComponent);
    modalRef.componentInstance.authorization = this.authorization;
    modalRef.componentInstance.accountDetails = this.customerAccount;

  }



}
